import React from 'react';
import { Card as CardReactStrap, CardBody as CardBodyReactStrap } from 'reactstrap';
import PropTypes from 'prop-types';
import { cn } from 'helpers/css';

const propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  styleCardBody: PropTypes.object,
  className: PropTypes.string,
};

const Card = ({
  title,
  subTitle,
  children,

  classNameContainer,
  styleContainer,

  className,
  styleCardBody,

  classNameTitleContainer,
  classNameTitle,
  onClickTitle,
}) => {
  //! State

  //! Function

  //! Render
  return (
    <CardReactStrap style={styleContainer} className={classNameContainer}>
      <CardBodyReactStrap className={className} style={styleCardBody}>
        {title && (
          <div className={cn(classNameTitleContainer, 'tw-mb-4 tw-flex tw-justify-between')}>
            <h5 className={cn(classNameTitle)} onClick={onClickTitle}>
              {title}
            </h5>

            {subTitle && <span className='text-muted'>{subTitle}</span>}
          </div>
        )}
        {children}
      </CardBodyReactStrap>
    </CardReactStrap>
  );
};

Card.propTypes = propTypes;
export default React.memo(Card);
